<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{
                                $t("inicio")
                                }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'configuracion-carta' }">
                                {{ $t("configuracionCarta") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page" @click="contadorEasterEgg += 1">
                            {{ $t("kiosksMenu") }}
                        </li>
                    </ol>
                </nav>
            </div>



            <div class="col-md-12">
                <div class="card p-3">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>
                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="permisoCarta()" :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- <div class="col-md-5" v-if="listCartas.length > 1">
              <div class="form-group">
                <label><strong>{{ $t("cartaASecas") }}</strong></label>
                <el-select class="select-default" size="large" v-model="idCarta" @change="getProductosCarta()"
                  filterable :placeholder="$t('seleccionaUnaCarta')">
                  <el-option v-for="cart in listCartas" class="select-primary" :value="cart.id"
                    :label="cart.nombreMostrado" :key="cart.id">
                  </el-option>
                </el-select>
              </div>
            </div> -->
                    </div>
                </div>
            </div>



            <div class="col-md-3 text-right">
                <div class="input-group">
                    <input type="text" class="form-control" v-bind:placeholder="$t('buscar')" v-model="searchQuery"
                        @keyup.enter.prevent="searchProductoCarta()" />
                    <div class="input-group-append">
                        <button class="btn btn-secondary" type="button" @click="searchProductoCarta">
                            <i class="fa fa-search"></i>
                        </button>
                        <button class="btn btn-secondary" type="button" @click="removeProductoCarta()">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-12" v-for="cat in listProductosCarta">
                <p style="
                    color: #1E22AA;
                    margin: 10px 0px;
                    font-size: 25px;
                    font-family: 'Numier', 'Helvetica Neue', Arial;
                    font-weight: bold;">
                    {{ cat.nombre }}
                </p>

                <div class="">
                    <table class="table table-bordered table-striped">
                        <thead class="thead-dark">
                            <tr>
                                <th v-if="!editarProductos">{{ $t("imagen") }}</th>
                                <th v-if="activeCarta && listCartas.length > 1">
                                    {{ $t("carta") }}
                                </th>
                                <th v-if="!idTipo">{{ $t("tipo") }}</th>
                                <th>{{ $t("nombre") }}</th>
                                <!-- <th>{{ $t("producto") }}</th> -->
                                <th>{{ $t("nombreEnTpv") }}</th>
                                <!-- <th>{{ $t("precioTarifa") }}</th>
                  <th>{{ $t("tarifa2") }}</th>
                  <th>{{ $t("tarifa3") }}</th>
                  <th>{{ $t("tarifa4") }}</th> -->
                                <th>{{ $t("categoria") }}</th>
                                <th class="text-center">{{ $t("acciones") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="obj in cat.productos">
                                <tr>
                                    <td width="5%" v-if="!editarProductos">
                                        <div>
                                            <template v-if="obj.img">
                                                <img @click="openModalEditar(obj)" width="100%"
                                                    :src="obj.img + '?' + obj.updated" />
                                            </template>

                                            <template v-else>
                                                <img @click="openModalEditar(obj)" width="100%"
                                                    src="https://www.numier.com/cartadigital/no-products.png" />
                                            </template>
                                        </div>
                                    </td>

                                    <!--No se usa-->
                                    <td v-if="activeCarta && listCartas.length > 1">
                                        <template v-if="!obj.modifier || !editarProductos">
                                            <div>
                                                {{ obj.nombreCarta }}
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div>
                                                <input type="text" v-model="obj.nombreCarta"
                                                    class="form-control input-sm" id="producto-name" />
                                            </div>
                                        </template>
                                    </td>
                                    <!--Hasta aqui-->

                                    <td width="10%" v-if="!idTipo">
                                        <template v-if="!obj.modifier || !editarProductos">
                                            <div class="px-2">
                                                <template v-if="obj.tipoCarta === 'C'">{{
                                                    $t("cartaASecas")
                                                }}</template>
                                                <template v-else-if="obj.tipoCarta === 'P'">{{
                                                    $t("pedido")
                                                }}</template>
                                                <template v-else>{{ $t("cartaYPedido") }}</template>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="px-0">
                                                <el-select class="select-default" size="large" v-model="obj.tipoCarta"
                                                    filterable :placeholder="$t('seleccionaTipo')">
                                                    <el-option v-for="filter in listTipoProductoCarta"
                                                        class="select-primary" :value="filter.value"
                                                        :label="filter.label" :key="filter.value">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </template>
                                    </td>

                                    <td width="15%">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <span class="d-inline-block" v-bind:style="[
                                                !obj.noDisponible
                                                    ? {
                                                        'text-decoration': 'line-through',
                                                        'white-space': 'nowrap',
                                                        overflow: 'hidden',
                                                        'text-overflow': 'ellipsis',
                                                        'max-width': '200px',
                                                    }
                                                    : {
                                                        'white-space': 'nowrap',
                                                        overflow: 'hidden',
                                                        'text-overflow': 'ellipsis',
                                                        'max-width': '200px',
                                                    },
                                            ]" :title="obj.nameProducto">{{ obj.nameProducto }}</span>
                                            <span style="color: red" v-if="obj.baja">
                                                [{{ $t("BAJA") }}]
                                            </span>
                                        </div>
                                        <div v-else>
                                            <div>
                                                <input type="text" v-model="obj.nameProducto"
                                                    class="form-control input-sm" id="producto-name" />
                                            </div>
                                        </div>
                                    </td>

                                    <td width="15%">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <span v-bind:style="[
                                                !obj.noDisponible
                                                    ? {
                                                        'text-decoration': 'line-through',
                                                        'white-space': 'nowrap',
                                                        overflow: 'hidden',
                                                        'text-overflow': 'ellipsis',
                                                        'max-width': '200px',
                                                    }
                                                    : {
                                                        'white-space': 'nowrap',
                                                        overflow: 'hidden',
                                                        'text-overflow': 'ellipsis',
                                                        'max-width': '200px',
                                                    },
                                            ]">{{ obj.nombreProductoRef }}</span>
                                        </div>
                                        <div v-else>
                                            <div>
                                                <!--<input
                            type="text"
                            v-model="obj.nombreProductoRef"
                            class="form-control input-sm"
                            id="producto-name"
                          /> -->
                                                <el-select class="select-default" v-model="obj.idProducto" filterable
                                                    remote reserve-keyword :remote-method="searchProducto"
                                                    :placeholder="$t('nombreDelProductoEnElTpv')">
                                                    <el-option class="select-primary" :value="'0'"
                                                        :label="$t('productoCartaSinRelacionar')">
                                                    </el-option>
                                                    <el-option v-for="p in listProductos" :key="p.id" :label="p.name"
                                                        :value="p.id">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- <td width="8%">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <span v-bind:style="[
                                                !obj.noDisponible
                                                    ? { 'text-decoration': 'line-through' }
                                                    : {},
                                            ]">{{ obj.precioTarifa1 | currency }}</span>
                                        </div>
                                        <div v-else>
                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                currency-symbol-position="suffix" :precision="2"
                                                v-model="obj.precioTarifa1" class="form-control input-sm"
                                                id="producto-name" :disabled="obj.modifier &&
                                                    (distinguirPrecios || distinguirPreciosCarta)
                                                    " @keydown.native="$methods.evitarComasDecimales">
                                            </vue-numeric>
                                        </div>
                                    </td>

                                    <td width="8%">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <span v-bind:style="[
                                                !obj.noDisponible
                                                    ? { 'text-decoration': 'line-through' }
                                                    : {},
                                            ]">{{ obj.precioTarifa2 | currency }}</span>
                                        </div>
                                        <div v-else>
                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                currency-symbol-position="suffix" :precision="2"
                                                v-model="obj.precioTarifa2" class="form-control input-sm"
                                                id="producto-name" :disabled="obj.modifier &&
                                                    (distinguirPrecios || distinguirPreciosCarta)
                                                    " @keydown.native="$methods.evitarComasDecimales">
                                            </vue-numeric>
                                        </div>
                                    </td>

                                    <td width="8%">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <span v-bind:style="[
                                                !obj.noDisponible
                                                    ? { 'text-decoration': 'line-through' }
                                                    : {},
                                            ]">{{ obj.precioTarifa3 | currency }}</span>
                                        </div>
                                        <div v-else>
                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                currency-symbol-position="suffix" :precision="2"
                                                v-model="obj.precioTarifa3" class="form-control input-sm"
                                                id="producto-name" :disabled="obj.modifier &&
                                                    (distinguirPrecios || distinguirPreciosCarta)
                                                    " @keydown.native="$methods.evitarComasDecimales">
                                            </vue-numeric>
                                        </div>
                                    </td>

                                    <td width="8%">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <span v-bind:style="[
                                                !obj.noDisponible
                                                    ? { 'text-decoration': 'line-through' }
                                                    : {},
                                            ]">{{ obj.precioTarifa4 | currency }}</span>
                                        </div>
                                        <div v-else>
                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                currency-symbol-position="suffix" :precision="2"
                                                v-model="obj.precioTarifa4" class="form-control input-sm"
                                                id="producto-name" :disabled="obj.modifier &&
                                                    (distinguirPrecios || distinguirPreciosCarta)
                                                    " @keydown.native="$methods.evitarComasDecimales">
                                            </vue-numeric>
                                        </div>
                                    </td> -->

                                    <td width="10%" class="px-0">
                                        <div v-if="!obj.modifier || !editarProductos">
                                            <div v-if="obj.nombreCategoria" class="px-2">
                                                {{ obj.nombreCategoria }}
                                            </div>
                                            <div v-else>{{ $t("sinCategoria") }}</div>
                                        </div>
                                        <div v-else class="px-0">
                                            <div>
                                                <el-select class="select-default" size="large" v-model="obj.idCategoria"
                                                    filterable :placeholder="$t('seleccionaUnaCategoria')">
                                                    <el-option v-for="filter in listCategories" class="select-primary"
                                                        :value="filter.id" :label="filter.nombre" :key="filter.id">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </td>
                                    <!-- La función getPermisoCarta en la API realiza una consulta SELECT para verificar si, para un determinado idBusiness, existe una configuración
                    asociada al "control de idiomas" (por ejemplo, una entrada con idConfig=38). Si se encuentra dicha configuración, esta contiene un valor que indica
                    si está activa (1 para activado). Toda esta información se almacena en el objeto resultante que se devuelve al cliente.
                    
                    Aquí en el Front-End, se consulta la propiedad configcarta.controlIdiomas, la cual se alimenta de los datos devueltos por getPermisoCarta. Si esta 
                    propiedad es true, se muestra un ícono de globo (que representa la gestión de idiomas) y se habilita la funcionalidad para abrir el formulario de 
                    idiomas mediante el método abrirModalIdiomas(obj).-->
                                    <td align="center" width="8%">
                                        <template v-if="!editarProductos">

                                            <!-- Acción 1: Traducir el producto a otros idiomas. Se muestra un ícono de globo si el control de idiomas está habilitado
                        en la configuración (configcarta.controlIdiomas). 
                          - class="btn btn-link btn-xs" le aporta un estilo, clases provienen de una biblioteca como Bootstrap.
                          - v-tooltip.top-center="$t('tolTipIdiomaProducto')": muestra un tooltip (mensaje flotante de ayuda) y $t(...): busca en el archivo de idiomas el texto asociado a'tolTipIdiomaProducto' 
                          - :key: Es una forma de enlazar dinámicamente una clave única al botón para ayudar a Vue a identificarlo.
                          - configcarta.toString(): Convierte el objeto configcarta (contiene configuraciones de la carta por ejemplo, si se permiten idiomas) en una cadena para usarlo como clave.
                          - @click="abrirModalIdiomas(obj)" al hacer click llama al método abrirModalIdiomas(obj) y le pasa como obj el producto que el usuario va a traducir. 
                          - v-if="configcarta.controlIdiomas" determina si este bloque debe mostrarse. Comprueba si la propiedad controlIdiomas dentro de configcarta es true.
                          -->
                                            <!-- <div class="btn btn-link btn-xs"
                                                v-tooltip.top-center="$t('tolTipIdiomaProducto')"
                                                :key="configcarta.toString()" @click="abrirModalIdiomas(obj)"
                                                v-if="configcarta.controlIdiomas">
                                                <i class="fas fa-globe-americas" style="color: #1f51ff"></i>
                                            </div> -->

                                            <!-- Acción 2: Editar el producto. Botón que redirige al formulario de edición del producto en la carta -->
                                            <div class="btn btn-link btn-xs" v-tooltip.top-center="$i18n.t('editar')">
                                                <div @click="abrirModalRotura(obj)">
                                                    <i style="color: orange" 
                                                        class="fas fa-pencil-alt"> &nbsp;</i>Editar disponibilidad
                                                </div>

                                            </div>

                                            <!-- Acción 3: Marcar como disponible o no disponible. Checkbox para cambiar el estado de disponibilidad del producto en la carta -->
                                            <!-- <div class="btn btn-danger btn-link btn-xs"
                                                v-tooltip.top-center="$t('tolTipDisponibleProducto')">
                                                <el-checkbox @change="
                                                    changeNoDisponible(obj.id, obj.noDisponible)
                                                    " v-model="obj.noDisponible">
                                                    <template></template>
    <strong>{{
        obj.noDisponible
        ? $t("disponible")
        : $t("noDisponible")
        }}
    </strong>
    </el-checkbox>
    </div> -->
                                        </template>
                                        <template v-else>
                                            <template v-if="obj.modifier === false">
                                                <button class="btn btn-primary" @click="obj.modifier = true">
                                                    <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-cog"></i>
                                                </button>
                                            </template>
                                            <template v-else>
                                                <button class="btn btn-success" @click="editProduct(obj)">
                                                    <i v-tooltip.top-center="$t('guardar')" class="far fa-save"></i>
                                                </button>
                                            </template>
                                        </template>
                                        <!--<div v-if="!obj.baja" @click="openModalBaja(obj.id)"-->
                                        <!--class="btn btn-danger btn-link btn-xs">-->
                                        <!--<i v-tooltip.top-center="'Dar de baja producto'" class="fas fa-trash-alt"></i>-->
                                        <!--</div>-->
                                        <!--<div v-else @click="openModalAlta(obj.id)"-->
                                        <!--class="btn btn-success btn-link btn-xs">-->
                                        <!--<i v-tooltip.top-center="'Dar de alta producto'" class="fas fa-undo"></i>-->
                                        <!--</div>-->
                                    </td>
                                </tr>
                                <tr v-if="obj.modifier &&
                                    (distinguirPrecios || distinguirPreciosCarta)
                                ">
                                    <td colspan="9" class="p-0">
                                        <div class="table-responsive p-0 m-0">
                                            <table class="table m-0">
                                                <thead>
                                                    <tr class="bg-secondary">
                                                        <th colspan="5" class="text-light">
                                                            Modificar Precios
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th></th>
                                                        <th>Tarifa 1</th>
                                                        <th>Tarifa 2</th>
                                                        <th>Tarifa 3</th>
                                                        <th>Tarifa 4</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="table-active">A recoger</th>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa1"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa2"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa3"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa4"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="distinguirPrecios">
                                                        <th class="table-active">A domicilio</th>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa1_d"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa2_d"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa3_d"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa4_d"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="distinguirPreciosCarta">
                                                        <th class="table-active">Carta Digital</th>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa1_c"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa2_c"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa3_c"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                        <td>
                                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                                currency-symbol-position="suffix" :precision="2"
                                                                v-model="obj.precioTarifa4_c"
                                                                class="form-control input-sm" id="producto-name"
                                                                @keydown.native="
                                                                    $methods.evitarComasDecimales
                                                                ">
                                                            </vue-numeric>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr class="bg-secondary p-0">
                                                        <th colspan="5" class="text-light"></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </td>
                                    <!-- </tr>
                  <tr v-if="obj.modifier">
                    <th>A domicilio</th>
                    <td colspan="3"></td>
                    <td colspan="3"></td>
                    <td colspan="3"></td> -->
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

            </div>






        </div>

        <modal :name="'stock-break'" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">
                        Editar disponibilidad - {{ productoEditar.nameProducto }} 


                    </h4>
                </div>

                <div class="modal-body" style="padding-left: 20pt; padding-right: 20pt;">

                    <p>
                        Seleccione los kioscos en los que desee marcar el producto como <strong>NO DISPONIBLE</strong> .
                    </p>

                    <el-checkbox 
                        v-for="tpv in listTpv" 
                        @change="updateStockBreakCheckbox(productoEditar, tpv)"
                        :key="tpv.id"
                        :checked="listTpvStockBreak.includes(tpv.id)"    
                    >
                        <strong>{{ tpv.nameShow }}</strong>
                    </el-checkbox>

                    <br>

                    <div class="d-flex justify-content-center">
                        <button class="btn btn-danger mt-4" @click="hideModalRotura()">
                            <i class="fa fa-solid fa-circle-xmark"></i>
                            Cancelar
                        </button>

                        <button class="btn btn-primary mt-4" style="margin-left: 20pt;" @click="updateStockBreak()">
                            <i class="fa fa-solid fa-circle-check"></i>
                            Guardar
                        </button>
                    </div>



                    <!-- <div class="col-12">
                        <el-select class="select-default" size="large" v-model="idTpvData" filterable
                            @change="cambioTpv()" placeholder="SeleccionaTPV">
                            <el-option class="select-primary" :value="-1" :label="'Seleccione un TPV'">
                            </el-option>
                            <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id"
                                :label="tpv.nameShow" :key="tpv.id">
                            </el-option>
                        </el-select>
                    </div> -->
                </div>

                <!-- <div class="modal-body">
                    <label for="idioma">{{ $t("idioma") }}:</label>
                    <br />
                    <el-select class="select-default" size="large" v-model="selectedLang" @change="cambiarTraducciones"
                        :placeholder="'Selecciona un idioma'">
                        <el-option v-for="lang in langList" class="select-primary" :value="lang.idLang"
                            :label="lang.name" :key="lang.idLang">
                        </el-option>
                    </el-select>
                    <br />
                    <div id="ingles" class="mt-3">
                        <label for="traduccion">{{ $t("nombre") }}: </label>
                        <input id="traduccion" class="form-control" type="text" v-model="traduccion" />
                        <br />
                        <label for="traduccion">{{ $t("descripcion") }}: </label>
                        <input class="form-control" type="text" v-model="traduccionDesc" />
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-default" @click="(img = ''), $modal.hide('anadir-idioma')">
                        <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-success" @click="cambiarIdiomaAProducto(productoEditar)">
                        <i class="fa fa-check-circle"></i>
                        {{ $t("guardar") }}
                    </button>
                </div> -->

            </div>
        </modal>


    </div>
</template>

<script>

import {
    DatePicker,
    Select,
    Option,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Button,
    Checkbox,
    CheckboxGroup,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

let p1,
    p2,
    p3,
    p4,
    p5 = null;

export default {
    name: "KioskosCarta",

    created() {
        this.getBusiness();

        this.$store.dispatch("setNameRoute", "Kioskos Carta");

    },

    data() {
        return {
            listProductosCarta: [],
            listCategories: [],
            listProductos: [],
            listBusinesses: [],
            listTpv: [],
            idBusiness: 0,
            listCartas: [],
            idCarta: 0,
            editarProductos: false,
            activeCarta: false,
            idTipo: "",

            searchQuery: "",

            configcarta: {},

            productoEditar: {},

            idTpvData: -1,
            listTpvData: [],
            listTpvStockBreak: [],
            //Kioskos en los que esta dado de baja un producto
            listKiosksInProduct: []


        }
    },

    methods: {
        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {
                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                        if (
                            vm.$store.getters.idBusiness == 2753 ||
                            vm.$store.getters.idBusiness == 4213 ||
                            vm.$store.getters.idBusiness == 4426 ||
                            vm.$store.getters.idBusiness == 4483 ||
                            vm.$store.getters.idBusiness == 4554 ||
                            vm.$store.getters.idBusiness == 4557 ||
                            vm.$store.getters.idBusiness == 4604 ||
                            vm.$store.getters.idBusiness == 3520
                        ) {
                            vm.isMasakali = true;
                        }
                    } else {
                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.listBusinesses = response.data.result;

                    vm.editarProductos = false;

                    vm.permisoCarta();
                    vm.getCategoriesCarta();
                    vm.searchProducto("");
                    // vm.getConfigDistinguirPrecio();
                    // vm.getConfigDistinguirPrecioCarta();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        permisoCarta() {
            const selectedBusiness = this.listBusinesses.find(
                (business) => business.id == this.idBusiness
            );

            if (selectedBusiness && selectedBusiness.selfi === "1") {
                this.isSelfi = true;

                swal({
                    title: this.$t("nosmudamos"),
                    text: this.$t("noscambiamosaselfi"), // Puedes traducir este texto si usas i18n
                    confirmButtonClass: "btn btn-warning btn-fill",
                    type: "warning",
                    showCloseButton: true, // Muestra la "X" en la esquina superior derecha
                    confirmButtonText: this.$t("irASelfibar"), // Texto del botón de confirmación
                    reverseButtons: true, // Invierte los botones para que el botón de confirmación esté primero
                }).then((result) => {
                    console.log(result);
                    if (result.value) {
                        this.redirectToSelfibar();
                    }
                });
            } else {
                this.isSelfi = false;
                // this.checkSinqroConfig();
                //Get categorias cuando cambia de negocio
                this.getCategoriesNumier();
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        estado: this.estado,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listCartas = [
                                {
                                    nombreMostrado: vm.$t("esteNegocioNoContieneNingunaCarta"),
                                    id: 0,
                                },
                            ];
                            vm.idCarta = 0;

                            if (response.data.result.permiso) {
                                vm.permiso = response.data.result.permiso;
                                vm.sellingPoint =
                                    response.data.result.listCartas[0].sinqroSellingPoint;

                                //vm.nameRoute = response.data.result.nameroute;
                                //vm.logoNegocio = response.data.result.imagen;

                                vm.listCartas = response.data.result.listCartas;

                                response.data.result.listCartas.forEach(function (x) {
                                    if (x.tokenServerSinqro) {
                                        vm.tokenServerSinqro = x.tokenServerSinqro;
                                    }

                                    if (x.tokenUserSinqro) {
                                        vm.tokenUserSinqro = x.tokenUserSinqro;
                                    }

                                    if (x.tiene_sinqro) {
                                        if (x.tiene_sinqro == "1") {
                                            vm.tieneSinqro = true;
                                        } else {
                                            vm.tieneSinqro = false;
                                        }
                                    }

                                    if (x.noRecoger == true) {
                                        vm.noRecoger = "1";
                                    } else {
                                        vm.noRecoger = "0";
                                    }

                                    if (x.noDomicilio == true) {
                                        vm.noDomicilio = "1";
                                    } else {
                                        vm.noDomicilio = "0";
                                    }

                                    if (x.multiCartaSinqro == true) {
                                        vm.multiCartaSinqro = true;
                                    } else {
                                        vm.multiCartaSinqro = false;
                                    }
                                    let encontrado = false;
                                    x.config.forEach((element) => {
                                        if (element.nombre == "tituloDestacados") {
                                            vm.tituloDestacados = element.valor;
                                            encontrado = true;
                                        }
                                    });

                                    if (!encontrado) {
                                        vm.tituloDestacados = "Productos destacados";
                                    }
                                });
                                vm.idCarta = response.data.result.listCartas[0].id;
                                vm.lastUploadedSinqro =
                                    response.data.result.listCartas[0].lastUploadedSinqro;
                                vm.descripcionCarta =
                                    response.data.result.listCartas[0].descripcionCarta;

                                /*vm.noRecoger = response.data.result.listCartas[0].config.filter(
                                  (item) => item.idConfig == "22"
                                )[0];
                                vm.noDomicilio = response.data.result.listCartas[0].config.filter(
                                  (item) => item.idConfig == "7"
                                )[0];*/
                                vm.editarProductos = false;

                                vm.searchProducto("");
                                // vm.getConfigDistinguirPrecio();
                                // vm.getConfigDistinguirPrecioCarta();
                                vm.getProductosCarta();
                                vm.getCategoriesCarta();
                            } else {
                                vm.permiso = response.data.result.permiso;
                            }
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    });
            }
        },

        getCategoriesCarta() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(
                    this.$store.getters.apiUrl + "delivery/getCategoriesCartaSinPadres",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.listCategories = [];

                        for (let i = 0; i < response.data.result.length; i++) {
                            let categoryname = {
                                nombre: response.data.result[i].nombre,
                                id: String(response.data.result[i].id),
                            };

                            vm.listCategories.push(categoryname);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getCategoriesNumier() {
            var vm = this;
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            p3 = this.axios
                .get(this.$store.getters.apiUrl + "delivery/getCategoriesCarta", config)
                .then(function (responseProds) {
                    vm.categoriesNumierList = responseProds.data.result;
                    vm.catsDone = true;
                })
                .catch(function (error) {
                    vm.loading.close();
                    console.log(error);
                });
        },

        searchProducto(query) {
            let busqueda = query;
            if (!this.listProductos.length > 0) {
                busqueda = "";
            }
            // if (query !== "") {
            const controller = "searchProductsTpv";
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    query: busqueda,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listProductos = response.data.result.products;
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            // }
        },

        searchProductoCarta() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    query: this.searchQuery,
                    baja: this.baja,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(
                    this.$store.getters.apiUrl + "delivery/searchProductosCarta",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.activeCarta = vm.searchQuery === "" ? false : true;

                        vm.listProductosCarta = response.data.result;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getProductosCarta() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    idTipo: this.idTipo,
                    idCarta: this.idCarta,
                    baja: this.baja,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(this.$store.getters.apiUrl + "delivery/getProductsCarta", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listProductosCarta = response.data.result;

                        vm.respuesta = true;
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });

                        vm.respuesta = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            const tempconfig = this.listCartas.find((elm) => elm.id == this.idCarta)
                .config;

            /*this.listCartas.forEach(carta => {
              if(this.idCarta == carta.id) {
                this.sellingPoint = carta.sellingPoint;
              }
            });*/

            if (tempconfig && tempconfig.length > 0) {
                tempconfig.forEach((element) => {
                    const el = {};
                    el[element.nombre] = element.valor != 0;
                    Object.assign(this.configcarta, el);
                    //  this.configcarta.push(el)
                });
            }
        },

        getTpv() {
            // this.listTpv = [];
            this.idsTPV = [];
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getKiosksTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        // vm.listTpv = [];
                        vm.idsTPV = [];

                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id);
                            vm.listTpv.push(response.data.result[i]);
                        }

                        //vm.idTpv = response.data.result[0].id;

                        vm.listCheckBoxTpv = response.data.result;

                        // for (let i = 0; i < response.data.result.length; i++) {
                        //     let printername = {
                        //         nameShow: response.data.result[i].nameShow,
                        //         id: response.data.result[i].id,
                        //     };

                        //     vm.listTpv.push(printername);
                        // }

                        // vm.getVentas();
                        // vm.hasSageDespacho();
                        // vm.hasDimoni();
                        // vm.grafica = 0;
                    }
                    // vm.loading.close();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        abrirModalRotura(producto) {
            this.listTpvStockBreak = [];
            this.listTpv = [];
            let vm = this;
            this.productoEditar = producto;
            this.getTpv()

            // this.listTpvStockBreak = [
            //     "10422"
            // ]

            // this.getKiosksForProduct(producto.id);

            this.getKiosksForProduct(producto.id).then(() => {
                this.$modal.show("stock-break");
            });

            // vm.$modal.show("stock-break");

        },

        hideModalRotura(){
            let vm = this;
            vm.$modal.hide("stock-break");

        },

        updateStockBreakCheckbox(producto, tpv) {

            if (this.listTpvStockBreak.includes(tpv.id)) {
                this.listTpvStockBreak.pop(tpv.id)
            } else {

                this.listTpvStockBreak.push(tpv.id)
            }

            console.log("lista", this.listTpvStockBreak);
        },

        updateStockBreak() {
            let postData = {
                product: this.productoEditar.id,

                idTpvs: this.listTpvStockBreak
            }

            console.log("post", postData);

            let config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            let params = postData;

            let vm = this;

            this.axios
                .post(
                    this.$store.getters.apiUrl + "products/insertProductsKioskoNotAvailable",
                    params,
                    config
                )
                .then(function (response) {
                        vm.$notify({
                            message: "Producto guardado correctamente",
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });


                   
                });

            vm.$modal.hide("stock-break");

        },

        //Para traer en que kioskos esta dado de baja un producto en concreto
        async getKiosksForProduct(idProduct){
                        // this.listTpv = [];
            var config = {
                params: {
                    idProduct: idProduct,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            return this.axios
                .get(this.$store.getters.apiUrl + "products/kioskosWithProductNotAvailable", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listTpvStockBreak = [];

                        for (let i = 0; i < response.data.result.idtpvs.length; i++) {
                            vm.listTpvStockBreak.push(response.data.result.idtpvs[i]);
                        }

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }


    },

    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Option.name]: Option,
    },

}


</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Kioskos/KioskosCarta.vue